export enum LocalStorage {
  CartId = 'cartId',
}
